module.exports = __webpack_public_path__ + "img/mirkacars_logo.75802fae.jpg";